// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Transient feedback ("+N", "Too Short", ...). No backplate. Sits over the
   word-in-progress; cleared immediately when a new word starts being spelled. */
.feedbackOverlay {
  position: fixed;
  margin-top: -10px;
  left: 0;
  right: 0;
  text-align: center;
  font-family: var(--font-display);
  font-size: 2.2rem;
  font-weight: 700;
  color: var(--palette-text);
  pointer-events: none;
  animation-duration: 2s;
  animation-name: feedbackPop;
  animation-fill-mode: forwards;
  animation-timing-function: cubic-bezier(0.65, 0.05, 0.36, 1);
}

@keyframes feedbackPop {
  from {
    opacity: 0;
    scale: 1;
  }
  10% {
    opacity: 1;
    scale: 1;
  }
  66% {
    opacity: 1;
    scale: 1;
  }
  99% {
    opacity: 0;
    scale: 3;
  }
  to {
    opacity: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/screens/components/feedbackOverlay.css"],"names":[],"mappings":"AAAA;gFACgF;AAChF;EACE,eAAe;EACf,iBAAiB;EACjB,OAAO;EACP,QAAQ;EACR,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,oBAAoB;EACpB,sBAAsB;EACtB,2BAA2B;EAC3B,6BAA6B;EAC7B,4DAA4D;AAC9D;;AAEA;EACE;IACE,UAAU;IACV,QAAQ;EACV;EACA;IACE,UAAU;IACV,QAAQ;EACV;EACA;IACE,UAAU;IACV,QAAQ;EACV;EACA;IACE,UAAU;IACV,QAAQ;EACV;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":["/* Transient feedback (\"+N\", \"Too Short\", ...). No backplate. Sits over the\n   word-in-progress; cleared immediately when a new word starts being spelled. */\n.feedbackOverlay {\n  position: fixed;\n  margin-top: -10px;\n  left: 0;\n  right: 0;\n  text-align: center;\n  font-family: var(--font-display);\n  font-size: 2.2rem;\n  font-weight: 700;\n  color: var(--palette-text);\n  pointer-events: none;\n  animation-duration: 2s;\n  animation-name: feedbackPop;\n  animation-fill-mode: forwards;\n  animation-timing-function: cubic-bezier(0.65, 0.05, 0.36, 1);\n}\n\n@keyframes feedbackPop {\n  from {\n    opacity: 0;\n    scale: 1;\n  }\n  10% {\n    opacity: 1;\n    scale: 1;\n  }\n  66% {\n    opacity: 1;\n    scale: 1;\n  }\n  99% {\n    opacity: 0;\n    scale: 3;\n  }\n  to {\n    opacity: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
